import {TimkenGearApex, TimkenGearRotation, TimkenHand, TimkenTorqueOrPower, TimkenGearDrive} from './types';
import { SelectOption } from '../types/types';

// Get Gear types from window
export const gearTypes = window?._timken?.gearTypes as string[] || {};

export const additionalText = window?._timken?.additionalText as string;

// Gear Type Videos
export const gearTypeVideos = window?._timken?.gearTypeVideos as Record<string, string>;

// Gear Hand List
export const handList: SelectOption<TimkenHand>[] = [
	{
		id: 'hand_left',
		value: '-1',
		label: 'Left',
		default: true,
	},
	{
		id: 'hand_right',
		value: '1',
		label: 'Right',
	},
];

// Torque or Power
export const torqueOrPowerOption: SelectOption<TimkenTorqueOrPower>[] = [
	{
		id: 'output_torque',
		value: '2',
		label: 'Torque',
	},
	{
		id: 'output_power',
		value: '1',
		label: 'Power',
	},
];

// Gear Drive options
export const gearDriveOption: SelectOption<TimkenGearDrive>[] = [
	{
		id: 'drive_driven',
		value: '-1',
		label: 'Driven',
	},
	{
		id: 'drive_driver',
		value: '1',
		label: 'Driver'
	},
];

// Direction of rotation
export const directionRotationOption: SelectOption<TimkenGearRotation>[] = [
	{
		id: 'rotation_counterclockwise',
		value: '-1',
		label: 'Counterclockwise',
	},
	{
		id: 'rotation_clockwise',
		value: '1',
		label: 'Clockwise'
	},
];

// Direction of rotation
export const gearApexOption: SelectOption<TimkenGearApex>[] = [
	{
		id: 'apex_left',
		value: '-1',
		label: 'Left',
	},
	{
		id: 'apex_right',
		value: '1',
		label: 'Right'
	},
];

//
export const formText: { [key: string]: string; } = {
	angleDeg: 'deg',
	selectOne: 'Select one',
	gearName: 'Gear Name'
}

// Form error messages
export const errorMessages: { [key: string]: string; } = {
	angle: "Value should be between -360° and 360°",
	pressureAngle: "Value should be between 15° and 35°",
	positiveNumber: "Value should be non-zero",
	percentage: "Value should be between 0 and 100",
	required: "Required",
	centerDistance: "The Center Distance must be greater than 1/2 of the Mean Working Diameter",
	anglePositive: "Value should be between 1 and 360°",
}

// Results information copy
export const resultsCopy: { [key: string]: string; } = {
	tableTitle: 'Gear Forces at Mesh Angle',
}
